module.exports = __webpack_public_path__ + "static/img/digita_02.7cad9c07.jpg";